export default "__VITE_ASSET__CN44Xsx8__"